import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { ServiceEvents } from '../shared/interfaces';
import { EndPoints } from '../EndPoints';
import { ItemCategory, ItemCategoryFilters } from '../../models/ItemCategory';

const useItemCategoryService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetCategories, setFetchingGetCategories] = useState(false);
    const [fetchingCreateCategory, setFetchingCreateCategory] = useState(false);
    const [fetchingStoreCategory, setFetchingStoreCategory] = useState(false);
    const [fetchingEditCategory, setFetchingEditCategory] = useState(false);
    const [fetchingUpdateCategory, setFetchingUpdateCategory] = useState(false);
    const [fetchingDeleteCategory, setFetchingDeleteCategory] = useState(false);
    const [fetchingActiveCategory, setFetchingActiveCategory] = useState(false);

    const getCategories = (filters: ItemCategoryFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        const url = `${EndPoints.ITEM_CATEGORIES.GET_ITEM_CATEGORIES}?${queryString}`;

        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetCategories
        });
    };

    const createCategory = (events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.ITEM_CATEGORIES.GET_ITEM_CATEGORIES,
            setFetching: setFetchingCreateCategory
        });
    };

    const storeCategory = (category: ItemCategory, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.ITEM_CATEGORIES.STORE_ITEM_CATEGORY,
            body: category,
            setFetching: setFetchingStoreCategory
        });
    };

    const editCategory = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.ITEM_CATEGORIES.EDIT_ITEM_CATEGORY.replace(':id', id.toString()),
            setFetching: setFetchingEditCategory
        });
    };

    const updateCategory = (id: number, category: ItemCategory, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.ITEM_CATEGORIES.UPDATE_ITEM_CATEGORY.replace(':id', id.toString()),
            body: category,
            setFetching: setFetchingUpdateCategory
        });
    };

    const deleteCategory = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.ITEM_CATEGORIES.DELETE_ITEM_CATEGORY.replace(':id', id.toString()),
            setFetching: setFetchingDeleteCategory
        });
    };

    const activeCategory = (id: number, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.ITEM_CATEGORIES.ACTIVE_ITEM_CATEGORY.replace(':id', id.toString()),
            setFetching: setFetchingActiveCategory
        });
    };

    return {
        // states
        fetchingGetCategories,
        fetchingCreateCategory,
        fetchingStoreCategory,
        fetchingEditCategory,
        fetchingUpdateCategory,
        fetchingDeleteCategory,
        fetchingActiveCategory,
        // methods
        getCategories,
        createCategory,
        storeCategory,
        editCategory,
        updateCategory,
        deleteCategory,
        activeCategory
    };
};

export default useItemCategoryService;
